import TawkChat from "./components/TawkChat";
import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { router } from 'routes';

import { initializeGA } from 'utils/analytics';

function App() {
  console.log('TESTING!!!');

  useEffect(() => {
    initializeGA(); // Initialize GA when the app starts
  }, []);

  return (
    <SnackbarProvider>
      <RouterProvider router={router} />
      {/* chat widget is mounted globally once */}
      <TawkChat />
    </SnackbarProvider>
  );
}

export default App;
